export default __webpack_public_path__ + "static/animation-img2-302f4d8124b3c60f5796e4d583975e75.webp";